import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { useAssetModalPanel } from "~/components/AssetModalV2/AssetModalPanelsContextProvider";
import { ChaptersPanel } from "~/components/AssetModalV2/Content/Panel/components/ChaptersPanel";
import { PDFOutlinePanel } from "~/components/AssetModalV2/Content/Panel/components/PDFOutlinePanel";
import { PrivateTranscriptPanel } from "~/components/AssetModalV2/Content/Panel/Transcript/PrivateTranscriptPanel";
import { ReturnToCurrentWordButton } from "~/components/AssetModalV2/Content/Panel/Transcript/ReturnToCurrentWordButton";
import { TranscriptScrollInfoProvider } from "~/providers/TranscriptScrollInfoProvider";
export const LeftContentPanel = /*#__PURE__*/ memo(()=>{
    const { activeLeftContentPanel } = useAssetModalPanel();
    if (activeLeftContentPanel === "transcript") {
        return /*#__PURE__*/ _jsx("div", {
            className: "relative h-full min-h-0",
            children: /*#__PURE__*/ _jsxs(TranscriptScrollInfoProvider, {
                children: [
                    /*#__PURE__*/ _jsx(PrivateTranscriptPanel, {}),
                    /*#__PURE__*/ _jsx("div", {
                        className: "pointer-events-none absolute inset-0",
                        children: /*#__PURE__*/ _jsx(ReturnToCurrentWordButton, {})
                    })
                ]
            })
        });
    }
    let content;
    if (activeLeftContentPanel === "pdfOutline") {
        content = /*#__PURE__*/ _jsx(PDFOutlinePanel, {});
    }
    if (activeLeftContentPanel === "chapters") {
        content = /*#__PURE__*/ _jsx(ChaptersPanel, {});
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "relative h-full min-h-0",
        children: content
    });
});
LeftContentPanel.displayName = "LeftContentPanel";
